import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useQuery } from "@apollo/client";
import { getCompareByLot } from "../../queries/queries";
import SelectedTable from "../SelectedTable/selectedTable";
import { selectApartment } from "../../redux/selectors/apartment.selectors";
import {
  addLotRowAction,
  addManyRowsLotAction,
  removeAllLotRowsAction,
  removeManyRowsAction,
  removeRowAction,
} from "../../redux/actions/selectedRows.actions";
import SelectedTableToolBar from "../SelectedTable/selectedTableToolBar";
import {
  optionsArea,
  optionsDateLead,
  optionsProperty,
} from "../../utils/optionsUtilities";
import { selectHasLotRows } from "../../redux/selectors/selectedRows.selectors";
import { selectPricingData } from "../../redux/selectors/pricingData.selectors";
import { setWarningsAndIdsAction } from "../../redux/actions/warnings.actions";
import { validateOnSelection } from "../../redux/utils/warnings.utlis";
import { addFlagRowDataAction } from "../../redux/actions/flagSelectionData.actions";

const ByLotContainer = (props) => {
  const {
    addLotRow,
    apartment,
    removeRow,
    removeManyRows,
    addManyLotRows,
    sourceOptions,
    statusOptions,
    hasLotRows,
    removeAllLotRows,
    formValues,
    setWarningsAndIds,
    addFlagRow,
  } = props;

  const { loteID, area, inmuebleID, garajes, ascensores } = apartment;

  const [optionArea, setOptionArea] = useState("+/- 5 m²");
  const [filterArea, setFilterArea] = useState(5);

  const [garageFilter, setGarageFilter] = useState(garajes > 0 ? true : false);
  const [elevatorFilter, setElevatorFilter] = useState(
    ascensores > 0 ? true : false
  );

  const [sourceName, setSourceName] = useState(["Ventana"]);
  const [sourceIds, setSourceIds] = useState([1]);

  const [statusName, setStatusName] = useState(["Todas"]);
  const [statusIds, setStatusIds] = useState([0]);

  const [dateLeadName, setDateLeadName] = useState("Menos de 6 meses");
  const [filterDate, setFilterDate] = useState(6);

  const [propertyName, setPropertyName] = useState([
    `${apartment.labelInmueble}`,
  ]);
  const [propertyIds, setPropertyIds] = useState([apartment.tipoInmueble]);

  const { loading, error, data } = useQuery(
    getCompareByLot(
      loteID,
      inmuebleID,
      area,
      filterArea,
      garageFilter ? 1 : 0,
      elevatorFilter ? 1 : 0,
      sourceIds,
      filterDate,
      propertyIds,
      statusIds
    )
  );

  useEffect(() => {
    if (hasLotRows && loading) removeAllLotRows();
  }, [loading, hasLotRows, removeAllLotRows]);

  useEffect(() => {
    if (data?.getComparableByLot) {
      data.getComparableByLot.forEach((row) => {
        if (row.area_flag) {
          let tempObj = {
            area_flag: row.area,
            varareaFlag: row.area_flag,
          };
          addFlagRow({ rowId: row.id, data: tempObj });
        }
        if (row.garaje_flag) {
          let tempObj = {
            garaje_flag: row.garajes,
            vargarajeFlag: row.garaje_flag,
          };
          addFlagRow({ rowId: row.id, data: tempObj });
        }
        if (row.bano_flag) {
          let tempObj = {
            bano_flag: row.banos,
            varbanoFlag: row.bano_flag,
          };
          addFlagRow({ rowId: row.id, data: tempObj });
        }
        if (row.piso_flag) {
          let tempObj = {
            piso_flag: row.num_piso,
            varpisoFlag: row.piso_flag,
          };
          addFlagRow({ rowId: row.id, data: tempObj });
        }
        if (row.ascensor_flag) {
          let tempObj = {
            ascensor_flag: row.num_ascensores,
            varpisoFlag: row.ascensor_flag,
          };
          addFlagRow({ rowId: row.id, data: tempObj });
        }
        if (row.antiguedad_flag) {
          let tempObj = {
            antiguedad_flag: row.anos_antiguedad,
            varantiguedadFlag: row.antiguedad_flag,
          };
          addFlagRow({ rowId: row.id, data: tempObj });
        }
        if (row.conjunto_edificio_flag) {
          let tempObj = {
            conjunto_edificio_flag: row.conjunto_edificio,
            varconjuntoEdificioFlag: row.conjunto_edificio_flag,
          };
          addFlagRow({ rowId: row.id, data: tempObj });
        }
        if (row.tipo_inmueble_id_flag) {
          let tempObj = {
            tipo_inmueble_id_flag: row.tipo_inmueble_id,
            vartipoInmuebleIdFlag: row.tipo_inmueble_id_flag,
          };
          addFlagRow({ rowId: row.id, data: tempObj });
        }
        if (row.valorm2_flag) {
          let tempObj = {
            valorm2_flag: row.valormt2,
            varvalorM2Flag: row.valorm2_flag,
          };
          addFlagRow({ rowId: row.id, data: tempObj });
        }
      });
    }
  }, [data, addFlagRow]);

  const lotRowHandler = (row, isSelected) => {
    if (isSelected) return removeRow(row.id);
    addLotRow(row);
    const validationRes = validateOnSelection({
      formValues,
      apartment,
      selectedRows: [row],
    });
    if (validationRes.warningMessages.length === 0) return;
    setWarningsAndIds(validationRes);
  };

  const addManyRowsHandler =
    ({ rows, noRowsSelected }) =>
    () => {
      if (!noRowsSelected) return removeManyRows(rows);
      addManyLotRows(rows);
      const validationRes = validateOnSelection({
        formValues,
        apartment,
        selectedRows: rows,
      });
      if (validationRes.warningMessages.length === 0) return;
      setWarningsAndIds(validationRes);
    };

  return (
    <SelectedTable
      title="Comparables en el conjunto"
      rows={data?.getComparableByLot || []}
      rowSelectionHandler={lotRowHandler}
      addManyRowsHandler={addManyRowsHandler}
      areaCompare={area}
      error={error}
      loading={loading}
      type={1}
    >
      <SelectedTableToolBar
        title="Comparables en el conjunto"
        optionsArea={optionsArea}
        setOptionArea={setOptionArea}
        textArea={optionArea}
        setFilterArea={setFilterArea}
        setGarageFilter={setGarageFilter}
        garageFilter={garageFilter}
        setElevatorFilter={setElevatorFilter}
        elevatorFilter={elevatorFilter}
        sourceOptions={sourceOptions}
        sourceName={sourceName}
        setSourceName={setSourceName}
        sourceIds={sourceIds}
        setSourceIds={setSourceIds}
        statusOptions={statusOptions}
        statusName={statusName}
        setStatusName={setStatusName}
        statusIds={statusIds}
        setStatusIds={setStatusIds}
        optionsDateLead={optionsDateLead}
        dateLeadName={dateLeadName}
        setDateLeadName={setDateLeadName}
        setFilterDate={setFilterDate}
        optionsProperty={optionsProperty}
        propertyName={propertyName}
        setPropertyName={setPropertyName}
        propertyIds={propertyIds}
        setPropertyIds={setPropertyIds}
      />
    </SelectedTable>
  );
};

const mapStateToProps = (state) => ({
  apartment: selectApartment(state),
  formValue: selectPricingData(state),
  hasLotRows: selectHasLotRows(state),
});

const mapDispatchToProps = (dispatch) => ({
  addLotRow: (kv) => dispatch(addLotRowAction(kv)),
  removeRow: (id) => dispatch(removeRowAction(id)),
  removeManyRows: (rows) => dispatch(removeManyRowsAction(rows)),
  addManyLotRows: (rows) => dispatch(addManyRowsLotAction(rows)),
  removeAllLotRows: () => dispatch(removeAllLotRowsAction()),
  setWarningsAndIds: (payload) => dispatch(setWarningsAndIdsAction(payload)),
  addFlagRow: (fieldData) => dispatch(addFlagRowDataAction(fieldData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ByLotContainer);
